import { render, staticRenderFns } from "./LotteryModal.vue?vue&type=template&id=bf7b4252&scoped=true"
import script from "./LotteryModal.vue?vue&type=script&lang=js"
export * from "./LotteryModal.vue?vue&type=script&lang=js"
import style0 from "./LotteryModal.vue?vue&type=style&index=0&id=bf7b4252&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b4252",
  null
  
)

export default component.exports